// FILE PATH: eRFQFrontend/src/component/Vendor/LogisticViewRFQ/ViewLogisticQuote.jsx

import { Box, Button, Typography } from "@mui/material";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

const ViewLogisticQuote = () => {
  const { logisticDraftId } = useParams();
  const navigate = useNavigate();
  const storedUser = JSON.parse(localStorage.getItem("user")) || {};
  const vendorId = JSON.parse(localStorage.getItem("vendor"));

  const [quote, setQuote] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const getQuote = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/logistic/quote?vendorId=${vendorId}&logisticDraftId=${logisticDraftId}`,
          { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
        );
        setQuote(res.data);
      } catch (error) {
        console.log(error);
      } finally {
        setIsLoading(false);
      }
    };
    getQuote();
  }, [logisticDraftId]);

  const cellStyle = { padding: "10px", border: "1px solid #dee2e6", fontSize: "13px" };
  const labelStyle = {
    padding: "10px",
    width: "35%",
    backgroundColor: "#fcfcfc",
    fontWeight: "bold",
    border: "1px solid #dee2e6",
    fontSize: "13px",
  };
  const valueStyle = { padding: "10px", fontSize: "13px", border: "1px solid #dee2e6" };

  if (isLoading) return <div style={{ padding: 40 }}>Loading...</div>;
  if (!quote) return <div style={{ padding: 40 }}>No quote found.</div>;

  const grandTotal = (quote.quoteItems || []).reduce(
    (sum, item) => sum + parseFloat(item.total || 0),
    0
  );

  return (
    <div>
      <Typography variant="h4" sx={{ mb: 3 }}>
        Quotes Information
      </Typography>

      <Box className="dashboard-container" px={5} py={3}>
        <table style={{ width: "100%", borderCollapse: "collapse" }}>
          <tbody>
            <tr>
              <td style={labelStyle}>Logistic RFQ ID</td>
              <td style={valueStyle}>{logisticDraftId}</td>
            </tr>

           
          </tbody>
        </table>

        <table border={1} style={{ borderCollapse: "collapse", width: "100%", marginTop: "10px" }}>
          <thead>
            <tr>
              <th style={cellStyle}>Sr.</th>
              <th style={cellStyle}>Particulars</th>
              <th style={cellStyle}>UOM</th>
              <th style={cellStyle}>Quantity</th>
              <th style={cellStyle}>Currency</th>
              <th style={cellStyle}>Rate</th>
              <th style={{ ...cellStyle, textAlign: "right" }}>Total (INR)</th>
              <th style={cellStyle}>Remark</th>
            </tr>
          </thead>

          <tbody>
            {(quote.quoteItems || []).sort((a, b) => a.srNo - b.srNo).map((item, idx) => (
              <tr key={idx}>
                <td style={{ ...cellStyle, textAlign: "center" }}>{idx + 1}</td>
                <td style={cellStyle}>{item.particulars}</td>
                <td style={{ ...cellStyle, textAlign: "center" }}>{item.unit}</td>
                <td style={{ ...cellStyle, textAlign: "center" }}>{item.quantity}</td>
                <td style={{ ...cellStyle, textAlign: "center" }}>{item.currency}</td>
                <td style={{ ...cellStyle, textAlign: "right" }}>{item.rate}</td>
                <td style={cellStyle}>{item.remark || "-"}</td>
                <td style={{ ...cellStyle, textAlign: "right" }}>{item.total}</td>
              </tr>
            ))}

            <tr style={{ fontWeight: "bold" }}>
              <td colSpan={7} style={{ ...cellStyle, textAlign: "right" }}>
                Grand Total
              </td>
              <td style={{ ...cellStyle, textAlign: "right" }}>{grandTotal}</td>
            </tr>
          </tbody>
        </table>
      </Box>

      <Box className="btn-container">
        <Button
          className="btn-outlined"
          onClick={() => navigate("/vendor/logistic-dashboard")}
        >
          Back
        </Button>
      </Box>
    </div>
  );
};

export default ViewLogisticQuote;
